import {cnCreateForm} from '../../FormModule';
import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import {IFormInput} from '../../initialValue';
import {Tumbler} from '../../../../../components/Tumbler/Tumbler';


function OtherValues({classNameValue} : {classNameValue: string}){
    const { setValue, getValues} = useFormContext<IFormInput>();
    const [crossFacadeMaterials, setCrossFacadeMaterials] = React.useState <boolean | undefined>(getValues("crossFacadeMaterials"));

    useEffect(() => {
        setValue("crossFacadeMaterials", crossFacadeMaterials);
    }, [crossFacadeMaterials, setValue]);

    return <>
        <h3 className={cnCreateForm('Header', [classNameValue])}>Дополнительные параметры:</h3>
        <Tumbler
            className={cnCreateForm('Tumbler')}
            checked={crossFacadeMaterials as boolean}
            callBack={(e) => setCrossFacadeMaterials(e.target.checked)}
            label="Модуль доступен во всех коллекциях"
        />
    </>;
}

export default OtherValues;